import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import indexX from '@/pages/index'
import register from '@/components/register.vue'
import login from '@/components/login.vue'
import home from '@/pages/home.vue'
import sign from '@/pages/sign.vue'
import addphotographer from '@/components/addphotographer.vue'
import exhibition from '@/pages/exhibition.vue'
import halldetail from '@/pages/detail/halldetail.vue'
import exhibitiondetail from '@/pages/detail/exhibitiondetail.vue'
import vote from '@/pages/vote.vue'
import Journalism from '@/pages/Journalism.vue'
import soliciting from '@/pages/detail/soliciting.vue'
import hand from '@/pages/hand.vue'
import search from '@/pages/search.vue'
import personal from '@/pages/personal.vue'
import account from '@/pages/account.vue'
import modify from '@/pages/modify.vue'
import examine from '@/pages/examine.vue'
import newsDetails from '@/pages/newsDetail.vue'
import schedule from '@/pages/schedule.vue'
import htm from '@/pages/htm.vue'
import parent from '@/pages/parent.vue'
import ShoppingMall from '@/pages/ShoppingMall.vue'
import shopDetail from '@/pages/shopDetail.vue'
import detail from '@/pages/detail.vue'
import shopCar from '@/pages/shopCar.vue'
import information from '@/pages/information.vue'
import Cashier from '@/pages/Cashier.vue'
import goodsdetail from '@/pages/goodsdetail.vue'
import refunddetail from '@/pages/refunddetail.vue'
import pingyaoShow from '@/pages/newPage/pingyaoShow.vue'
import richText from '@/pages/newPage/richText.vue'
import timeLine from '@/pages/newPage/timeLine.vue'
import yearShow from '@/pages/newPage/yearShow.vue'
import signUp from '@/pages/newPage/signUp.vue'
import aboutShow from '@/pages/newPage/aboutShow.vue'
import contactInfo from '@/pages/newPage/contactInfo.vue'
import signLabel from '@/pages/signLabel.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path:'/sign',
      name:'sign',
      component:sign
    },
    {
      path:'/refunddetail',
      name:'refunddetail',
      component:refunddetail
    },
    {
      path:'/goodsdetail',
      name:'goodsdetail',
      component:goodsdetail
    },
    {
      path:'/Cashier',
      name:'Cashier',
      component:Cashier
    },
    {
      path:'/information',
      name:'information',
      component:information
    },
    {
      path:'/shopCar',
      name:'shopCar',
      component:shopCar
    },
    {
      path:'/detail',
      name:'detail',
      component:detail
    },
    {
      path:'/shopDetail',
      name:'shopDetail',
      component:shopDetail
    },
    {
      path:'/ShoppingMall',
      name:'ShoppingMall',
      component:ShoppingMall
    },
    {
      path:'/htm',
      name:'htm',
      component:htm
    },
    {
      path:'/parent',
      name:'name',
      component:parent
    },
    {
      path:'/schedule',
      name:'schedule',
      component:schedule
    },
    {
      path:'/examine',
      name:'examine',
      component:examine
    },
    {
      path:'/modify',
      name:'modify',
      component:modify
    },
    {
      path:'/account',
      name:'account',
      component:account
    },
    {
      path:'/personal',
      name:'personal',
      component:personal
    },
    {
       path:'/newsDetails',
       name:'newsDetails',
       component:newsDetails
    },
    {
      path:'/journalism',
      name:'journalism',
      component:Journalism
    },
    {
      path:'/search',
      name:'search',
      component:search
    },
    {
      path:'/soliciting',
      name:'soliciting',
      component:soliciting
    },

    {
      path:'/hand',
      name:'hand',
      component:hand
    },
    {
      path:'/exhibitiondetail',
      name:'exhibitiondetail',
      component:exhibitiondetail
    },
    {
       path:'/halldetail',
       name:'halldetail',
       component:halldetail
    },
    {
      path:'/exhibition',
      name:'exhibition',
      component:exhibition
    },
    {
      path:'/vote',
      name:'vote',
      component:vote
    },
    {
      path:'/addphotographer',
      name:'addphotographer',
      component:addphotographer
    },
    {
      path:'/',
      name:'home',
      component:home
    },
    {
       path:'/login',
       name:'login',
       component:login
    },
    {
      path:'/register',
      name:'register',
      component:register
    },
    {
    path: '/index',
    name: 'indexX',
    meta: {
      auth: true //添加字段判断该页面是否需要登录
    },
    component: indexX
  },{
    path:'/s',
    name:'HelloWorld',
    meta: {
      auth: true //添加字段判断该页面是否需要登录
    },
    component:HelloWorld
  },
  {
    path:'/newPage/pingyaoShow',
    name:'pingyaoShow',
    component:pingyaoShow
  },
  {
    path:'/newPage/richText',
    name:'richText',
    component:richText
  },
  {
    path:'/newPage/timeLine',
    name:'timeLine',
    component:timeLine
  },
  {
    path:'/newPage/signUp',
    name:'signUp',
    component:signUp
  },
  {
    path:'/signLabel',
    name:'signLabel',
    component:signLabel
  },
  {
    path:'/newPage/yearShow',
    name:'yearShow',
    component:yearShow
  },
  {
    path:'/newPage/aboutShow',
    name:'aboutShow',
    component:aboutShow
  },
  {
    path:'/newPage/contactInfo',
    name:'contactInfo',
    component:contactInfo
  }
]
})



// WEBPACK FOOTER //
// ./src/router/index.js